const CONSTANTS = {
    WRAPPER_CLASS: 'global-tabs--js',
    FILTER_SELECTOR: '.filter__body .filter',
    FILTER_CLASS: 'filter',
    ACTIVE_FILTER_CLASS: 'active',
    HEADLINE_CLASS: 'global-tabs__title',
    TAB_CLASS: 'global-tab',
    ACTIVE_CLASS: 'tab-active'
};

let options = {
    wrapperClass: CONSTANTS.WRAPPER_CLASS,
    filterSelector: CONSTANTS.FILTER_SELECTOR,
    filterClass: CONSTANTS.FILTER_CLASS,
    activeFilterClass: CONSTANTS.ACTIVE_FILTER_CLASS,
    headlineClass: CONSTANTS.HEADLINE_CLASS,
    tabClass: CONSTANTS.TAB_CLASS,
    activeClass: CONSTANTS.ACTIVE_CLASS
};


class TabsController {

    constructor(tabsElem) {
        this.tabsElem = tabsElem
        const allHeaders = tabsElem.querySelectorAll(`${options.filterSelector}, .${options.headlineClass}`)
        const allTabs = tabsElem.querySelectorAll(`.${options.tabClass}`)
        if (allHeaders.length < 1 || allTabs.length < 1) {
            console.warn(`TabsController was initialized without tabs (${allHeaders.length} headers, ${allTabs.length} tabs) on element`, tabsElem);
            return
        }

        const activeHeaders = tabsElem.querySelectorAll(`${options.filterSelector}.${options.activeFilterClass}, .${options.headlineClass}.${options.activeClass}`)

        const activeTabs = tabsElem.querySelectorAll(`.${options.tabClass}.${options.activeClass}`)
        activeTabs.forEach(tab => tab.classList.remove(options.activeClass));
        activeHeaders.forEach(tab => tab.classList.remove(options.activeClass, options.activeFilterClass));

        if (activeHeaders.length === 1) {
            this.currentHeader = activeHeaders[0]
            const tabId = this.currentHeader.dataset.tab
            this.currenTab = document.getElementById(tabId)
            if (this.currenTab) {
                this.currenTab.classList.add(options.activeClass)
            }
        }
        // else is either 0 or invalid setup or invalid tab linking... make first header and first tab active even if they don't match
        if (!this.currentHeader || !this.currentTab) {
            this.currentHeader = allHeaders[0]
            this.currentTab = allTabs[0]

            if (this.currentHeader.classList.contains(options.filterClass)) {
                this.currentHeader.classList.add(options.activeFilterClass)
            }
            else {
                this.currentHeader.classList.add(options.activeClass)
            }
            this.currenTab.classList.add(options.activeClass)
        }

        this.currentTab = tabsElem.querySelector(`.${options.tabClass}.${options.activeClass}`)

        this.attachEventListeners()
    }

    attachEventListeners() {
        const headers = this.tabsElem.querySelectorAll(`${options.filterSelector}, .${options.headlineClass}`)
        headers.forEach(header => header.addEventListener('click', this.handleTabClick.bind(this)))
    }

    handleTabClick(event) {
        if (!event.currentTarget.dataset.tab) {
            return;
        }
        event.preventDefault();

        const nextHeader = event.currentTarget
        const tabId = nextHeader.dataset.tab
        const nextTab = document.getElementById(tabId)

        if (nextTab && nextTab !== this.currentTab) {
            if (this.currentHeader) {
                this.currentHeader.classList.remove(options.activeClass, options.activeFilterClass)
            }
            if (this.currentTab) {
                this.currentTab.classList.remove(options.activeClass)
            }
            if (nextHeader.classList.contains(options.filterClass)) {
                nextHeader.classList.add(options.activeFilterClass)
                this.tabsElem.querySelector('.filter__body').style.display = ''
                this.tabsElem.querySelector('.filter__head .filter').innerHTML = nextHeader.innerHTML
            }
            else {
                nextHeader.classList.add(options.activeClass)
            }
            nextTab.classList.add(options.activeClass)

            this.currentHeader = nextHeader
            this.currentTab = nextTab
        }
    }

}

const tabs = {
    init: (overwriteOptions) => {
        options = Object.assign(options, overwriteOptions);

        const globalTabElems = document.querySelectorAll(`.${options.wrapperClass}`);
        globalTabElems.forEach(tabsElem => new TabsController(tabsElem));
    }
};

export { tabs };
